import {
  JWT_DOMAIN,
  getJwtCookieName,
} from '@modules/auth/jwt/getJwtCookieName'
import Cookies from 'universal-cookie'
import isProductionEnv from './isProductionEnv'

export default function signOutUser(): void {
  const cookies = new Cookies()

  // Temporary to clean up deprecated jwt cookies, will remove
  // when forcing cut-over to new jwt cookie
  cookies.remove('jwt', {
    path: '/',
    sameSite: 'lax',
    secure: true,
  })

  cookies.remove(getJwtCookieName(), {
    domain: isProductionEnv() ? JWT_DOMAIN : undefined,
    path: '/',
    sameSite: 'lax',
    secure: true,
  })
}
